module.exports = __webpack_public_path__ + "static/media/vida_individual.62404c04.svg";